import { render, staticRenderFns } from "./LearningResources.vue?vue&type=template&id=2e91f810&scoped=true&"
import script from "./LearningResources.vue?vue&type=script&lang=js&"
export * from "./LearningResources.vue?vue&type=script&lang=js&"
import style0 from "./LearningResources.vue?vue&type=style&index=0&id=2e91f810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e91f810",
  null
  
)

export default component.exports